module.exports = __webpack_public_path__ + "assets/chevron-right-3da2aa082124f69aed44b50c5c5e2dc4.svg";